import { REVIEWER_NAME_DISPLAY_FORMAT } from "@apps/reviews/constants";
import { REWARDS_DISCOUNT_TYPES } from "@apps/rewards/constants/rewardsDiscountTypes";
import { REWARDS_REWARD_TYPES } from "@apps/rewards/constants/rewardsRewardTypes";
import { FormManagerValues } from "@lib/FormManager/types";
import MoneyFormatterInterface from "@modules/money/Formatters/MoneyFormatter/MoneyFormatterInterface";
import * as Yup from "yup";

import LeaveReviewEarningRuleEntity from "../../../entities/LeaveReviewEarningRuleEntity";

export const getReviewFormConfig = (
    isReviewTitleEnabled: boolean,
    isReviewTitleRequired: boolean,
    customerDisplayNamePolicy: REVIEWER_NAME_DISPLAY_FORMAT
) => {
    let schema: Yup.AnyObjectSchema = Yup.object({
        body: Yup.string().required("validation_field_required"),
    });
    let initialValues: FormManagerValues = {
        body: "",
    };

    if (isReviewTitleEnabled && isReviewTitleRequired) {
        schema = Yup.object({
            body: Yup.string().required("validation_field_required"),
            title: Yup.string().required("validation_field_required"),
        });
        initialValues = { body: "", title: "" };
    } else if (isReviewTitleEnabled) {
        schema = Yup.object({
            body: Yup.string().required("validation_field_required"),
            title: Yup.string(),
        });
        initialValues = { body: "", title: "" };
    }
    if (
        customerDisplayNamePolicy ===
        REVIEWER_NAME_DISPLAY_FORMAT.CUSTOMER_CHOICE
    ) {
        initialValues = {
            ...initialValues,
            customerDisplayNamePolicy: REVIEWER_NAME_DISPLAY_FORMAT.FULL_NAME,
        };
    }

    return { schema, initialValues };
};

export const getProductReviewSubTitleTranslation = (
    rewarding: LeaveReviewEarningRuleEntity["rewarding"] | undefined,
    pointsName: string,
    moneyFormatter: MoneyFormatterInterface
): {
    key: string;
    translationOptions: Record<string, string>;
} => {
    if (!rewarding) {
        return {
            key: "review_step_sub_title",
            translationOptions: {},
        };
    }

    switch (rewarding.type) {
        case REWARDS_REWARD_TYPES.discount:
            if (
                rewarding.discountType === REWARDS_DISCOUNT_TYPES.freeShipping
            ) {
                return {
                    key: "review_step_sub_title_free_shipping",
                    translationOptions: {},
                };
            }

            if (rewarding.discountType === REWARDS_DISCOUNT_TYPES.fixedAmount) {
                return {
                    key: "review_step_sub_title_fixed_amount",
                    translationOptions: {
                        amount: rewarding.discountValue
                            ? moneyFormatter.format_with_currency(
                                  Math.abs(rewarding.discountValue)
                              )
                            : "",
                    },
                };
            }
            if (rewarding.discountType === REWARDS_DISCOUNT_TYPES.percentage) {
                return {
                    key: "review_step_sub_title_percentage",
                    translationOptions: {
                        amount: rewarding.discountValue?.toString() || "",
                    },
                };
            }

            return {
                key: "review_step_sub_title",
                translationOptions: {},
            };
        case REWARDS_REWARD_TYPES.freeProduct:
            return {
                key: "review_step_sub_title_free_product",
                translationOptions: {
                    amount: rewarding.discountValue.toString(),
                    product_title: rewarding.productTitle,
                },
            };
        case REWARDS_REWARD_TYPES.giftCard:
            return {
                key: "review_step_sub_title_gift_card",
                translationOptions: {
                    amount: rewarding.initialValue
                        ? moneyFormatter.format_with_currency(
                              Math.abs(rewarding.initialValue)
                          )
                        : "",
                },
            };
        case REWARDS_REWARD_TYPES.points:
            return {
                key: "review_step_sub_title_points",
                translationOptions: {
                    points: rewarding.points.toString(),
                    points_name: pointsName,
                },
            };
        default:
            return {
                key: "review_step_sub_title",
                translationOptions: {},
            };
    }
};
